import React from "react";
import { Recycle, ShieldAlert, BookOpen } from "lucide-react";
import { postCoverImage } from "../../lib/blogApi";

const ICONS = { Recycle, ShieldAlert, BookOpen };

/**
 * Cover art for a blog card / hero. Uses `featuredImage` / `coverImage` if
 * the post has one, otherwise falls back to a green gradient + Lucide icon
 * so posts synced without an image still look on-brand.
 */
export default function BlogCover({ post, className = "aspect-[16/10]" }) {
  const cover = postCoverImage(post);
  if (cover) {
    return (
      <div
        className={`relative rounded-2xl overflow-hidden bg-moss-900 ${className}`}
      >
        <img
          src={cover}
          alt={post.title}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-cream-50/95 text-[10px] font-bold tracking-[0.14em] uppercase text-moss-950">
            {post.category}
          </span>
        </div>
      </div>
    );
  }

  const Icon = ICONS[post.coverIcon] || BookOpen;
  const gradient = post.coverBg || "from-moss-900 via-moss-800 to-moss-950";
  const accent = post.coverAccent || "text-sage-300";

  return (
    <div
      className={`relative rounded-2xl overflow-hidden bg-gradient-to-br ${gradient} ${className}`}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <Icon className={`w-24 h-24 ${accent} opacity-70`} strokeWidth={1.6} />
      </div>
      <div className="absolute top-4 left-4">
        <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-cream-50/95 text-[10px] font-bold tracking-[0.14em] uppercase text-moss-950">
          {post.category}
        </span>
      </div>
    </div>
  );
}
